/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import PlansComponent from './main';

export const index = (context, next) => {
    context.primary = <PlansComponent />;
    next();
};
